import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

export const Login = (): JSX.Element => {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    loginWithRedirect();
  }, [loginWithRedirect]);

  // Nothing to render, page just redirects to auth0
  return null;
};
